import { IcStatusVariants } from "../../utils/types";

export type IcBadgeTypes = "dot" | "text" | "icon";

export type IcBadgePositions = "far" | "near" | "inline";

export type IcBadgeVariants = IcStatusVariants | "light" | "custom";
